<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,3C7.45,3,7,3.45,7,4C7,4,7,8,7,8C7,8.28,7.11,8.53,7.29,8.71C7.29,8.71,9.29,10.71,9.29,10.71C9.47,10.89,9.72,11,10,11C10.55,11,11,10.55,11,10C11,9.72,10.89,9.47,10.71,9.29C10.71,9.29,9,7.59,9,7.59C9,7.59,9,4,9,4C9,3.45,8.55,3,8,3C8,3,8,3,8,3ZM8,0C5.6,0,3.46,1.07,2,2.74C2,2.74,2,1,2,1C2,0.45,1.55,0,1,0C0.45,0,0,0.45,0,1C0,1,0,5,0,5C0,5.55,0.45,6,1,6C1,6,5,6,5,6C5.55,6,6,5.55,6,5C6,4.45,5.55,4,5,4C5,4,3.54,4,3.54,4C4.64,2.78,6.23,2,8,2C11.31,2,14,4.69,14,8C14,10.61,12.33,12.81,10,13.63C10,13.63,10,13.62,10,13.62C9.37,13.85,8.71,14,8,14C4.69,14,2,11.31,2,8C2,7.45,1.55,7,1,7C0.45,7,0,7.45,0,8C0,12.42,3.58,16,8,16C8.34,16,8.67,15.97,9,15.93C9.02,15.93,9.04,15.92,9.06,15.92C12.98,15.4,16,12.06,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'History',
} as DefineComponent
</script>
